import { Chip } from '@mui/material';
import classNames from 'classnames';
import { type PropsWithChildren } from 'react';
import styles from './actionTag.module.scss';

type ActionTagProps = {
  onClick?: () => void;
  icon?: JSX.Element;
  className?: string;
  arialLabel?: string;
};

export function ActionTag(
  props: PropsWithChildren<ActionTagProps>
): JSX.Element {
  return (
    <Chip
      className={classNames(styles['action-tag'], props.className)}
      icon={props.icon}
      onClick={props.onClick}
      label={props.children}
    />
  );
}
